function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "91141443-0174-45E6-A861-A428CBBA0D56@1.00x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-608.000000, -512.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "paper-plane",
  transform: "translate(608.000000, 512.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("g", {
  id: "icon32/paper-plane",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.9983449,23.9515609 L17.2533449,25.3125609 L14.8436615,29.1028177 C14.6830483,29.3552098 14.4193473,29.5204954 14.1268851,29.5578732 L14,29.5659422 C13.4871642,29.5659422 13.0644928,29.179902 13.0067277,28.6825633 L13,28.5659422 L12.9983449,23.9515609 Z M29.5494754,3.39066841 C29.6582709,3.58786038 29.697317,3.81600402 29.6602902,4.03815301 L26.1898647,24.8596293 C26.0990651,25.4043988 25.5838345,25.7724142 25.0390649,25.6816146 C24.9915171,25.6736895 24.9446045,25.6623369 24.8986942,25.6476454 L18.3713449,23.5585609 L18.3633449,23.5685609 L14.2083449,22.2385609 L23,9 L10.0963449,20.9095609 L3.20983586,18.7071533 C2.68382694,18.5388291 2.39386621,17.9759608 2.56219046,17.4499519 C2.6400197,17.2067375 2.80794578,17.0025127 3.03153653,16.8791522 L28.1908203,2.99816807 C28.6743885,2.73137182 29.2826791,2.90710021 29.5494754,3.39066841 Z",
  id: "Combined-Shape"
})))));

var SvgPaperPlane = function SvgPaperPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper-plane.b4cba233.svg";
export { ForwardRef as ReactComponent };